<vwui-modal-header>
  <div class="w-full flex items-center">
    <h2>Foto's</h2>
    <vwui-badge class="ml-2 text-xs">{{photos.length}}</vwui-badge>
    <app-button class="ml-auto mr-4" (click)="downloadActivePhoto()" id="single-photo-download-button">
      <img src="/assets/icons/vwui-import.svg" class="h-4 w-4">
    </app-button>
  </div>
</vwui-modal-header>

<vwui-modal-body>
  <div class="relative select-none">
    <div class="flex items-center justify-center bg-dark" style="--aspect-ratio:16/9;">
      <img [src]="photoSrc" [srcset]="photoSrcset" sizes="(max-width: 1280px) 100vw, 1280px" class="object-contain">
    </div>
    @if (photos.length > 1) {
      <div
        class="absolute top-1/2 -translate-y-1/2 bg-white w-12 h-12 ml-12 rounded-full flex items-center justify-center cursor-pointer hover:bg-gray-200"
        (click)="previous()">
        <img src="/assets/icons/vwui-chevron-left.svg" class="h-3.5 w-3.5">
      </div>
    }
    @if (photos.length > 1) {
      <div
        class="absolute top-1/2 -translate-y-1/2 right-12 bg-white w-12 h-12 rounded-full flex items-center justify-center cursor-pointer hover:bg-gray-200"
        (click)="next()">
        <img src="/assets/icons/vwui-chevron-right.svg" class="h-3.5 w-3.5">
      </div>
    }
  </div>
</vwui-modal-body>
